export default {
    props: {
        justify: {
            type: String,
            default: 'start'
        },
        align: {
            type: String,
            default: 'start'
        }
    },
    computed: {
        alignmentClasses() {
            return {
                'justify-start': this.justify === 'start',
                'justify-center': this.justify === 'center',
                'justify-end': this.justify === 'end',
                'justify-between': this.justify === 'space-between',
                'justify-around': this.justify === 'space-around',
                'items-stretch': this.align === 'stretch',
                'items-start': this.align === 'start',
                'items-center': this.align === 'center',
                'items-end': this.align === 'end',
                'items-baseline': this.align === 'baseline',
            };
        }
    }
};